import React from 'react';

import { MinimalDetailsModal } from './minimal-details-modal';

export const DetailsModal = () => <MinimalDetailsModal />;
